// extracted by mini-css-extract-plugin
export var container = "Processes-module--container--kkokg";
export var none = "Processes-module--none--Wec+3";
export var squareWrap = "Processes-module--squareWrap--7ZXgd";